import React from 'react'
import DemoInputsSection from '../DemoInputsSection'
import DemoInputFileSimple from './DemoInputFileSimple'

const DemoInputFile = () => {

  return (
    <DemoInputsSection name="file">
      <DemoInputFileSimple/>
    </DemoInputsSection>
  )
}

export default DemoInputFile